import env from "../config/env";

const BASE_URL = env.API_URL || "https://iu9ozlcvo5.execute-api.us-east-1.amazonaws.com/dev";
const API_KEY = env.API_KEY || "";

const defaultHeaders = {
  "Content-Type": "application/json",
  ...(API_KEY ? { "x-api-key": API_KEY } : {})
};

const handleJsonResponse = async (response, fallbackMessage = "Error al procesar la solicitud") => {
  if (!response.ok) {
    throw new Error(fallbackMessage);
  }
  return response.json();
};

export const sendChatMessage = async ({ message, history, userName, userEmail, sessionId, formData }) => {
  const url = `${BASE_URL}/therapybot`;

  const payload = {
    session_id: sessionId,
    user_email: userEmail,
    user_name: userName,
    gender: formData.gender,
    user_age: formData.user_age,
    user_weight: formData.user_weight,
    user_height: formData.user_height,
    user_complexion: formData.user_complexion,
    user_religion: formData.user_religion,
    smoke: formData.smoke,
    drink_alcohol: formData.drink_alcohol,
    does_exercise: formData.does_exercise,
    use_drugs: formData.use_drugs,
    medicines: formData.medicines,
    diseases: formData.diseases,
    educational_level: formData.educational_level,
    personality: formData.personality,
    feelings: formData.feelings,
    sexual_preference: formData.sexual_preference,
    question: message,
    message_hystory: history,
  };

  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    headers: defaultHeaders,
    body: JSON.stringify(payload),
  });

  const jsonResponse = await handleJsonResponse(response, "No se pudo enviar el mensaje");
  return jsonResponse.body;
};

export const fetchUserProfile = async (email) => {
  const url = `${BASE_URL}/client/profile?user_email=${encodeURIComponent(email)}`;
  const response = await fetch(url, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    headers: defaultHeaders,
  });
  const jsonResponse = await handleJsonResponse(response, "No se pudo obtener el perfil del usuario");
  return jsonResponse.body;
};

export const sendResponseFeedback = async ({ userMessage, botResponse, ok }) => {
  const url = `${BASE_URL}/responseok`;
  const payload = {
    question: userMessage,
    answer: botResponse,
    ok,
  };

  const response = await fetch(url, {
    method: "POST",
    headers: defaultHeaders,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    console.error("No se pudo registrar el feedback de la respuesta");
  }
};
